<template>
  <div id="confirm-delete-popup"></div>
</template>

<script>
export default {
  name: 'ConfirmDeletePopup',
  created() {
    this.open();
  },
  methods: {
    open() {
      this.$confirm('确定要删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'attribute-delete-msgbox',
        center: true
      })
        .then(() => {
          this.$emit('onConfirmDelete');
        })
        .catch(() => {
          this.$prompt('已取消删除');
          this.$emit('onCancelDelete');
        });
    }
  }
};
</script>

<style lang="scss">
.attribute-delete-msgbox {
  width: 300px;
  height: 170px;
  .el-message-box__btns {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-around;
    width: 200px;
    margin: 0 auto;
    margin-top: 20px;
    button:nth-child(2) {
      margin-left: 0;
    }
  }
  .el-button {
    background-color: $color-primary;
    color: #fff;
  }
}
</style>
